import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { ifreaMediaAnalyticsDateRangeState } from "../../store/ifreaMediaAnalyticsDateRangeState";

export const useFetchTabelogAnalytics = (restaurantId?: string) => {
  const dateRange = useRecoilValue(ifreaMediaAnalyticsDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/tabelog-analytics/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: tabelogAnalytics, isLoading } = useSWR<any>(fetcherKey)
  return { tabelogAnalytics, isLoading };
};